__webpack_require__.p = "https://hbp.zabran.id/";